module.exports = __webpack_public_path__ + "static/media/Artboard2s.ea14dbf4.gif";